<template>
    <a
        ref="tooltip"
        v-tooltip.right="{
            popperClass: `tooltipIntegration--${index}`,
            content: itemTooltip(item),
            triggers: [],
            show: hoverIcon,
            container: 'body',
            boundary: 'body',
            html: true,
        }"
        class="dropdown-item dropdown-item--mergeFields"
        :class="{
            [`dropdown-item-field-${index}`]: true,
            disabledState: hasNotIntegration(item),
            'no-click': template,
        }"
        @click="applyMergeField(item)"
    >
        <span class="dropdown-item-info">
            <figure v-if="item.photo_url" class="image is-16x16 is-avatar">
                <img :src="item.photo_url" alt="" />
            </figure>
            <span>
                {{ $filters.limit(item.label, 22) }}
            </span>
        </span>
        <span v-if="hasNotIntegration(item)" class="dropdown-item-iconUnlink">
            <fa-icon :icon="['fas', 'unlink']" />
        </span>
    </a>
</template>

<script>
import filters from '../vue/filters';

export default {
    props: {
        template: { type: Boolean, default: false },
        item: { type: Object, default: {} },
        index: { type: Number },
        hasNotIntegration: { type: Function },
        checkDate: { type: Function },
    },

    emits: ['applyMergeField'],

    data: () => ({
        hoverIcon: false,
    }),

    methods: {
        itemTooltip(item) {
            if (this.hasNotIntegration(item)) {
                return 'Integration disconnected. <a class="integrationReconnect" href="#">Reconnect.</a>';
            }

            const string = this.checkDate(item.value).join(' ');

            if (!string) {
                return '';
            }

            return filters.limit(string, 100);
        },

        mouseoverIcon(e) {
            const target = e.target;
            const tooltip = document.querySelector(`.tooltipIntegration--${this.index}`);
            const tooltipWrap = this.$refs.tooltip;

            if (
                (tooltipWrap && tooltipWrap.contains(target)) ||
                (tooltip && tooltip.contains(target))
            ) {
                const link = document.querySelectorAll('.integrationReconnect');

                if (link.length) {
                    link.forEach((el) => {
                        el.removeEventListener('click', this.redirectToIntegrations);
                        el.addEventListener('click', this.redirectToIntegrations);
                    });
                }

                this.hoverIcon = true;
            } else {
                this.hoverIcon = false;
            }
        },

        redirectToIntegrations(e) {
            e.preventDefault();

            this.$router.push('/settings/integrations');
        },

        applyMergeField(item) {
            this.$emit('applyMergeField', item);
        },
    },

    mounted() {
        document.addEventListener('mouseover', this.mouseoverIcon);
    },

    beforeUnmount() {
        document.removeEventListener('mouseover', this.mouseoverIcon);
    },
};
</script>
